import { NavigationPath, NavPoiPath } from "@/types/navigation";
import { SightlineVerifierResponse } from "@/types/sightlineVerifier";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
const API_ROUTE_ENDPOINT = "/navigation";

type NavRouteData = {
  data: NavPoiPath;
  navAnswer: string;
}

type SightlineRouteData = {
  data: SightlineVerifierResponse;
}

type RouteData = NavRouteData | SightlineRouteData;

type SavedRoute = {
  success: boolean
  token: string
}

export async function getRoute(token: string): Promise<RouteData> {
  const url = `${BASE}${API_ROUTE_ENDPOINT}/${token}`
  console.log("url", url)
  const res = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  });

  if (!res.ok) throw new Error(`Failed: ${res.status}`);

  return res.json() as Promise<RouteData>;
}


export async function saveRoute(nav: any, navAnswer: any) {
  const url = `${BASE}${API_ROUTE_ENDPOINT}/save`
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ nav: nav, navAnswer: navAnswer })
  });

  if (!res.ok) throw new Error(`Failed: ${res.status}`);

  const data = (await res.json()) as SavedRoute;
  return data.token;
}
